var styles = {"actionElement":"base-link--action-element"};

export { styles as default };
//# sourceMappingURL=BaseLink.module.esm.js.map
